"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.DropDownContent = exports.ALIGN_WIDTH = exports.ALIGN_TOP = exports.ALIGN_BOTTOM = exports.ALIGN_CENTER = exports.ALIGN_RIGHT = exports.ALIGN_LEFT = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _OuterClick = _interopRequireDefault(require("../OuterClick"));

var _SlideDown = _interopRequireDefault(require("../SlideDown"));

var _Portal = _interopRequireDefault(require("../Portal"));

var _isRtl = _interopRequireDefault(require("../_utils/isRtl"));

require("./dropDown.sass");

var PAGE_OFFSET = 12;
var HORIZONTAL_ALIGN_MASK = 3;
var VERTICAL_ALIGN_MASK = 12;
var ALIGN_LEFT = 0;
exports.ALIGN_LEFT = ALIGN_LEFT;
var ALIGN_RIGHT = 1;
exports.ALIGN_RIGHT = ALIGN_RIGHT;
var ALIGN_CENTER = 1 << 1;
exports.ALIGN_CENTER = ALIGN_CENTER;
var ALIGN_BOTTOM = 1 << 2;
exports.ALIGN_BOTTOM = ALIGN_BOTTOM;
var ALIGN_TOP = 1 << 3;
exports.ALIGN_TOP = ALIGN_TOP;
var ALIGN_WIDTH = 1 << 4;
exports.ALIGN_WIDTH = ALIGN_WIDTH;

var DropDownContent = function DropDownContent(_ref) {
  var className = _ref.className,
      title = _ref.title,
      props = (0, _objectWithoutProperties2.default)(_ref, ["className", "title"]);

  var content = _react.default.createElement("div", (0, _extends2.default)({
    className: (0, _classnames.default)('dropDown-content', className)
  }, props));

  if (!title) {
    return content;
  }

  return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement("div", {
    className: "dropDown-title"
  }, title), content);
};

exports.DropDownContent = DropDownContent;
DropDownContent.propTypes = process.env.NODE_ENV !== "production" ? {
  title: _propTypes.default.node,
  className: _propTypes.default.string
} : {};

var isSameRect = function isSameRect(rectA, rectB) {
  if (!rectA || !rectB) {
    return false;
  }

  return ['left', 'top', 'right', 'bottom', 'x', 'y', 'width', 'height'].every(function (key) {
    return rectA[key] === rectB[key];
  });
};

var elementVisible = function elementVisible(rect) {
  return rect.bottom >= 0 && rect.bottom <= window.innerHeight;
};

var DropDown =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(DropDown, _React$Component);

  function DropDown() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, DropDown);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(DropDown)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "state", {
      width: 0,
      height: 0
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "onOuterClick", function (e) {
      if (e.target === _this.refs.element || _this.refs.element.contains(e.target)) {
        return false;
      }

      _this.hide();
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "show", function () {
      var rect = _this.refs.element.getBoundingClientRect();

      _this.setState({
        active: true,
        show: true,
        rect: rect
      });

      window.addEventListener('resize', _this.setPosition);
      window.addEventListener('scroll', _this.setPosition, {
        passive: true,
        capture: true
      });
      _this.props.onShow && _this.props.onShow();
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "hide", function () {
      _this.setState({
        show: false
      });

      window.removeEventListener('resize', _this.setPosition);
      window.removeEventListener('scroll', _this.setPosition, {
        passive: true,
        capture: true
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "onHide", function () {
      _this.props.onHide && _this.props.onHide();

      _this.setState({
        active: false
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "setPosition", function () {
      var _ref2 = _this.contentElement ? _this.contentElement.getBoundingClientRect() : {},
          width = _ref2.width,
          height = _ref2.height;

      if (width !== _this.state.width || height !== _this.state.height) {
        _this.setState({
          width: width,
          height: height
        });
      }

      var rect = _this.refs.element ? _this.refs.element.getBoundingClientRect() : null;

      if (!isSameRect(_this.state.rect, rect)) {
        _this.setState({
          rect: rect
        });
      }

      if (_this.state.show && rect && !elementVisible(rect)) {
        _this.hide();
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "fixPosition", function (element) {
      _this.contentElement = element;

      _this.setPosition();
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "handleClick", function (e) {
      e.stopPropagation();
      e.preventDefault();

      if (_this.state.show) {
        _this.hide();
      } else {
        _this.show();
      }
    });
    return _this;
  }

  (0, _createClass2.default)(DropDown, [{
    key: "getChildContext",
    value: function getChildContext() {
      return {
        hidePopup: this.hide
      };
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.setPosition);
      window.removeEventListener('scroll', this.setPosition, {
        passive: true,
        capture: true
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      // on IOs devices was bug PMN-3423
      if (this.contentElement) {
        this.setPosition();
      }
    }
  }, {
    key: "getPosition",
    value: function getPosition() {
      var _this$state = this.state,
          rect = _this$state.rect,
          width = _this$state.width,
          height = _this$state.height;
      var style = {};
      var align = this.align;

      if (!width && !height) {
        return {
          left: 0,
          top: 0
        };
      }

      switch (align & HORIZONTAL_ALIGN_MASK) {
        case ALIGN_RIGHT:
          style.right = window.innerWidth - rect.right;
          break;

        case ALIGN_CENTER:
          style.left = rect.left;
          break;

        default:
        case ALIGN_LEFT:
          style.left = Math.min(rect.left, window.innerWidth - width - PAGE_OFFSET);
          break;
      }

      switch (align & VERTICAL_ALIGN_MASK) {
        case ALIGN_TOP:
          style.top = Math.max(PAGE_OFFSET, rect.top - Math.max(0, rect.top + height - window.innerHeight + PAGE_OFFSET));
          break;

        default:
        case ALIGN_BOTTOM:
          if (rect.top + rect.height > window.innerHeight - height - PAGE_OFFSET && rect.top - height > PAGE_OFFSET) {
            style.bottom = window.innerHeight - rect.top;
          } else {
            if (height > window.innerHeight - rect.bottom - PAGE_OFFSET) {
              style.height = window.innerHeight - rect.bottom - PAGE_OFFSET;
              style.top = rect.bottom;
            } else {
              style.top = Math.max(PAGE_OFFSET, rect.bottom - Math.max(0, rect.bottom + height - window.innerHeight + PAGE_OFFSET));
            }
          }

          break;
      }

      if (align & ALIGN_WIDTH) {
        style.minWidth = rect.width;
      }

      return style;
    }
  }, {
    key: "handlePortalClick",
    value: function handlePortalClick(e) {
      e.stopPropagation();
    }
  }, {
    key: "renderDropDown",
    value: function renderDropDown() {
      var _this$state2 = this.state,
          active = _this$state2.active,
          show = _this$state2.show;

      if (!active) {
        return null;
      }

      return _react.default.createElement(_Portal.default, {
        className: "dropDown",
        onClick: this.handlePortalClick
      }, _react.default.createElement(_OuterClick.default, {
        className: "dropDown-container",
        style: this.getPosition(),
        onOuterClick: show ? this.onOuterClick : null
      }, _react.default.createElement(_SlideDown.default, {
        popdown: true,
        restrictMaxHeight: true,
        onRef: this.fixPosition,
        onHide: this.onHide,
        children: show && this.props.children
      })));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          trigger = _this$props.trigger,
          className = _this$props.className;
      return _react.default.createElement("div", {
        className: (0, _classnames.default)('dropDown-trigger', className),
        ref: "element",
        onClick: this.show
      }, typeof trigger === 'function' ? trigger({
        active: this.state.active
      }) : trigger, this.renderDropDown());
    }
  }, {
    key: "align",
    get: function get() {
      var align = this.props.align;

      if (!align) {
        if ((0, _isRtl.default)()) {
          return ALIGN_RIGHT | ALIGN_BOTTOM;
        } else {
          return ALIGN_LEFT | ALIGN_BOTTOM;
        }
      }

      return align;
    }
  }]);
  return DropDown;
}(_react.default.Component);

exports.default = DropDown;
(0, _defineProperty2.default)(DropDown, "childContextTypes", {
  hidePopup: _propTypes.default.func
});
DropDown.propTypes = process.env.NODE_ENV !== "production" ? {
  trigger: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.element]),
  className: _propTypes.default.string,
  align: _propTypes.default.number,
  children: _propTypes.default.node,
  onShow: _propTypes.default.func,
  onHide: _propTypes.default.func
} : {};